import React, { useEffect, useState } from 'react';
import '../../css/steps.css';
import Preloader from '../../Components/Preloader';
import Header from '../../Components/Header';
import Footer from '../../Components/Footer';
import { NavLink } from 'react-router-dom';
import DataSafety_Seo from '../../SEO/DataSafety_Seo';
import AOS from 'aos';

function DataSafety() {
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        // Simulate an asynchronous operation (e.g., fetching data)
        setTimeout(() => {
            setIsLoading(false);
        }, 500); // Simulating a 1-second delay
    }, []);
     useEffect(() => {
            AOS.init({
                duration: 3000,
                easing: 'ease-in-out',
                once: true,
                mirror: false,
            });
        }, []);
    return (
        <div>
            {isLoading ? (
                <Preloader />
            ) : (
                <>
                    <DataSafety_Seo />
                    <Header />
                    {/* Internal CSS */}
                    <style>
                        {`                           
                            .cardcss {
                                      box-shadow: 0 5px 40px 0 rgba(0,0,0,.11);
                                      margin: 0 0 20px 0;
                                      border-radius: 35px;
                                  }
                        `}
                    </style>
                    {/* Start Page Banner Area */}
                    <div className="page-banner-area position-relative overflow-hidden" style={{ backgroundImage: 'url(assets/images/hero/hero-image-2.svg)' }}>
                        <div className="container">
                            <div className="page-banner-content">
                                <h1>Data Safety</h1>
                                <ul>
                                    <li><NavLink to="/help">Help</NavLink></li>
                                    <li>Data Safety</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    {/* End Page Banner Area */}
                    {/* Help section start */}
                    <section className="style1 ptb-100">
                        <div className="container">
                            <div className="section-title">
                                <h2>Data Safety</h2>                                
                            </div>
                            <div className="row justify-content-center">
                                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                <p className='text-center'>If you have completed your registration with Ifepay but haven’t initiated any transaction, then you can send us a request to delete your account with us. Deleting your account will remove your data we have stored with us. </p>
                                    <div className="form-card">
                                        <div className="row text-center justify-content-center" data-aos-delay={300}>
                                            <h4 className="mb-2 mt-3">Temporary Account Deletion</h4>
                                            <p className="mb-5">
                                                Please follow the below steps to delete your account on a temporary basis.
                                            </p>
                                        </div>
                                        <div className="row justify-content-center">
                                            <div className="col-12 col-md-6 col-lg-6" data-aos-delay={300}>
                                                <div className="card cardcss">
                                                    <img className="card-img-top" src="assets/images/data-safety/1.png" alt="Data Safety" />
                                                    <div className="card-body">
                                                        <p className="card-text">
                                                            <strong>Step 1:</strong> Go to the dashboard and open
                                                            the ‘Settings’ tab. Click on the ‘Delete My Account’ option.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-6 col-lg-6" data-aos-delay={400}>
                                                <div className="card cardcss">
                                                    <img className="card-img-top" src="assets/images/data-safety/2.png" alt="Data Safety" />
                                                    <div className="card-body">
                                                        <p className="card-text mb-4">
                                                            <strong>Step 2:</strong> Click the ‘Yes’ option to
                                                            temporarily delete your account.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-6 col-lg-6" data-aos-delay={600}>
                                                <div className="card cardcss">
                                                    <img className="card-img-top" src="assets/images/data-safety/3.png" alt="Data Safety" />
                                                    <div className="card-body">
                                                        <p className="card-text">
                                                            <strong>Step 3:</strong> To proceed with your request, please click on
                                                            the ‘Yes’ option. We will delete all your data
                                                            records stored in our system. You can cancel the request by clicking on
                                                            the ‘No’ option.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <hr />
                                        <div className="row text-center justify-content-center" data-aos-delay={300}>
                                            <h4 className="mb-2 mt-3">Permanent Account Deletion</h4>
                                            <p className="mb-5">
                                                Please follow the below steps to delete your account permanently.
                                            </p>
                                        </div>
                                        <div className="row justify-content-center">
                                            <div className="col-12 col-md-6 col-lg-6" data-aos-delay={600}>
                                                <div className="card cardcss">
                                                    <img className="card-img-top" src="assets/images/data-safety/1.png" alt="Data Safety?" />
                                                    <div className="card-body">
                                                        <p className="card-text">
                                                            <strong>Step 1:</strong> Go to the dashboard and open
                                                            the ‘Settings’ tab. Click on the ‘Delete My Account’ option.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-6 col-lg-6" data-aos-delay={700}>
                                                <div className="card cardcss">
                                                    <img className="card-img-top" src="assets/images/data-safety/2.png" alt="Data Safety?" />
                                                    <div className="card-body">
                                                        <p className="card-text">
                                                            <strong>Step 2:</strong> Click on the ‘No. Delete my account
                                                            permanently’ option to delete your account
                                                            permanently.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-6 col-lg-6" data-aos-delay={800}>
                                                <div className="card cardcss">
                                                    <img className="card-img-top" src="assets/images/data-safety/4.png" alt="Data Safety?" />
                                                    <div className="card-body">
                                                        <p className="card-text mb-4">
                                                            <strong>Step 3:</strong> Your request for account
                                                            deletion will be submitted. Our team will reach out to you shortly.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-6 col-lg-6" data-aos-delay={900}>
                                                <div className="card cardcss">
                                                    <img className="card-img-top" src="assets/images/data-safety/5.png" alt="Data Safety?" />
                                                    <div className="card-body">
                                                        <p className="card-text">
                                                            <strong>Step 4:</strong> To proceed with your request, please click on
                                                            the ‘Yes’ option. We will delete all your data
                                                            records stored in our system.&nbsp;You can cancel the request by
                                                            clicking on the ‘No’ option.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12" data-aos-delay={900}>
                                                <p>
                                                    If you have completed your registration with Ifepay and have
                                                    processed your
                                                    transaction, you can also send us a request to delete your account.
                                                </p>
                                                <p>
                                                    But as per the Regulation 40 of The MLR 2017, we are liable:
                                                </p>
                                                <ul className="ul">
                                                    <li>
                                                        To store your documents and information we have collected from you as a
                                                        part of the
                                                        customer due diligence (CDD) process.
                                                    </li>
                                                    <li>
                                                        To store any supporting records including original documents or copies you
                                                        have provided to
                                                        us as a part of CDD.
                                                    </li>
                                                </ul>
                                                <p>
                                                    We will store your data for 5 years beginning from when your transactions have
                                                    been
                                                    completed for which you have provided us your data to process the transaction.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <h4 className="mb-3 mt-5">We will not delete your account and data stored with us in the below</h4>
                                                <p>
                                                    Please follow the below steps to delete your account permanently.
                                                </p>
                                                <p>
                                                    The period of 5 years will not be applicable in the following cases.
                                                </p>
                                                <p>
                                                    As per Regulation 40 (5), we will store your data if,
                                                </p>
                                                <ol className="ol">
                                                    <li>
                                                        We are liable to do so by or under any enactment,
                                                    </li>
                                                    <li>
                                                        For any court proceedings;
                                                    </li>
                                                    <li>
                                                        You have given consent to retain your data provided to us; or
                                                    </li>
                                                    <li>
                                                        If Ifepay has reasons to believe that your data records need to
                                                        be maintained
                                                        with us for legal proceedings.
                                                    </li>
                                                </ol>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    {/* Help section end */}
                    {/* Footer Section Here */}
                    <Footer />
                </>
            )}
        </div>
    );
}

export default DataSafety
